document.addEventListener('DOMContentLoaded', () => {
	const accordions = document.querySelectorAll('details');

	accordions.forEach(accordion => {
		const icon = accordion.querySelector('.fa');
		accordion.querySelector('summary').addEventListener('click', () => {
			if (accordion.hasAttribute('open')) {
				icon?.classList.remove('fa-minus');
				icon?.classList.add('fa-plus');
			} else {
				icon?.classList.remove('fa-plus');
				icon?.classList.add('fa-minus');
			}
		});
	});
});
